const STORAGE_KEY = 'enabledLogAnalytics';

/**
 * Send events to analytics
 * @class
 * @public
 */

class AnalyticsUtils {
	hasFlagLogAnalytics: string | null = null;

	hasGTMLoaded = false;

	#eventsQueue = [];

	constructor() {
		if (!__IS_SERVER__) {
			this.hasFlagLogAnalytics = localStorage.getItem(STORAGE_KEY);
			if (!this.hasFlagLogAnalytics) {
				localStorage.setItem(STORAGE_KEY, '');
			}

			window.dataLayer = window.dataLayer ?? [];
			this.hasGTMLoaded = !!window.dataLayer.find(eventObj => eventObj.event === 'gtm.load');

			if (!this.hasGTMLoaded) {
				const resolveEvents = () => {
					this.hasGTMLoaded = true;
					this.#eventsQueue.forEach(({ event, params }) => this.sendEvent(event, params));
				};

				const originalPush = window.dataLayer.push;

				window.dataLayer.push = function push(...args) {
					if (args[0].event === 'gtm.load') resolveEvents();
					return originalPush.apply(this, args);
				};
			}
		}
	}

	/**
	 * Send event with params
	 * @param {string} event name of event
	 * @param {*} params any data
	 * @public
	 */

	public sendEvent(event: string, params: unknown) {
		if (this.hasGTMLoaded) {
			document.dispatchEvent(new CustomEvent(event, { detail: params }));

			if (!!this.hasFlagLogAnalytics) {
				// eslint-disable-next-line no-console
				console.log(event, params);
			}
		} else {
			this.#eventsQueue.push({ event, params });
		}
	}
}

export const analyticsUtils = new AnalyticsUtils();
